import ManageSearchOutlinedIcon from "@mui/icons-material/ManageSearchOutlined";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";
import MoveToInboxOutlinedIcon from "@mui/icons-material/MoveToInboxOutlined";
import RuleOutlinedIcon from "@mui/icons-material/RuleOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import DomainOutlinedIcon from "@mui/icons-material/DomainOutlined";
import ModuleSideNav from "../../shared/ModuleSideNav";
import { useColorMode } from "../../../contexts/ColorModeContext";
import {
  DRAWER_WIDTH,
  DRAWER_WIDTH_COLLAPSED,
  NAV_ITEMS,
} from "./navConfig";

const ICONS = {
  Search: ManageSearchOutlinedIcon,
  Dashboard: SpaceDashboardOutlinedIcon,
  Inventory: FormatListBulletedOutlinedIcon,
  Add: NoteAddOutlinedIcon,
  Warehouse: MoveToInboxOutlinedIcon,
  Account: RuleOutlinedIcon,
  Check: TaskAltOutlinedIcon,
  Business: DomainOutlinedIcon,
};

const CadastrosMuiNav = (props) => {
  const { mode, toggleColorMode } = useColorMode();

  return (
    <ModuleSideNav
      moduleTitle="Cadastros"
      navItems={NAV_ITEMS}
      iconMap={ICONS}
      drawerWidth={DRAWER_WIDTH}
      drawerWidthCollapsed={DRAWER_WIDTH_COLLAPSED}
      getNavLinkEnd={(item) => item.path === "/modulo/cadastros/produtos"}
      mode={mode}
      toggleColorMode={toggleColorMode}
      {...props}
    />
  );
};

export default CadastrosMuiNav;
